import { Loader2 } from "lucide-react";
import React from "react";

export function SocialProfileDisconnectingState() {
  return (
    <div className="absolute inset-0 bg-white/60 backdrop-blur-[1px] z-10 flex flex-col items-center justify-center rounded-b-xl">
      <Loader2 className="animate-spin text-slate-400 mb-2" size={24} />
    </div>
  );
}
